import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaBuilding }       from '@react-icons/all-files/fa/FaBuilding';
import { FaLayerGroup }     from '@react-icons/all-files/fa/FaLayerGroup';
import { FaTruck }          from '@react-icons/all-files/fa/FaTruck';
import { FaUserFriends }    from '@react-icons/all-files/fa/FaUserFriends';
import { FaUserTie }        from '@react-icons/all-files/fa/FaUserTie';
import { FaConciergeBell }  from '@react-icons/all-files/fa/FaConciergeBell';
import { FaDollarSign }     from '@react-icons/all-files/fa/FaDollarSign';
import { FaCog }            from '@react-icons/all-files/fa/FaCog';
import { FaHome }           from '@react-icons/all-files/fa/FaHome';
import Breadcrumb from '../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../commons/TileContainer';

const tiles: TileItem[] = [
  { key: 'grupo-empresas',       label: 'Grupo de Empresas',      icon: <FaLayerGroup />,    color: '#8b5cf6' },
  { key: 'proveedor-empresa',    label: 'Proveedor de Empresa',   icon: <FaTruck />,          color: '#3b82f6' },
  { key: 'contacto-grupo',       label: 'Contacto de Grupo',      icon: <FaUserFriends />,    color: '#10b981' },
  { key: 'contacto-empresa',     label: 'Contacto de Empresa',    icon: <FaUserTie />,        color: '#0ea5e9' },
  { key: 'servicio-empresa',     label: 'Servicio de Empresa',    icon: <FaConciergeBell />,  color: '#f59e0b' },
  { key: 'precios',              label: 'Precios',                icon: <FaDollarSign />,     color: '#22c55e' },
];

function EmpresaIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',               icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',  icon: <FaCog /> },
        { label: 'Empresa',                              icon: <FaBuilding /> },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#8b5cf6' }}>
          <FaBuilding style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Empresa</h2>
          <p style={s.subtitle}>Configuración de empresa</p>
        </div>
      </div>

      <TileContainer
        tiles={tiles}
        onSelect={key => navigate(`/configuracion/empresa/${key}`)}
      />
    </div>
  );
}

function SubPage({ tileKey }: { tileKey: string }) {
  const tile = tiles.find(t => t.key === tileKey)!;

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',                       icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',          icon: <FaCog /> },
        { label: 'Empresa',       to: '/configuracion/empresa',  icon: <FaBuilding /> },
        { label: tile.label,                                     icon: tile.icon },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: tile.color }}>
          <span style={s.icon}>{tile.icon}</span>
        </div>
        <div>
          <h2 style={s.title}>{tile.label}</h2>
          <p style={s.subtitle}>Configuración de {tile.label.toLowerCase()}</p>
        </div>
      </div>

      <div style={s.placeholder}>
        <span style={{ fontSize: 32, color: '#cbd5e1' }}>{tile.icon}</span>
        <p style={{ margin: 0, color: '#94a3b8', fontSize: 14 }}>
          Configuración de <strong>{tile.label}</strong>
        </p>
      </div>
    </div>
  );
}

export default function EmpresaConfigPage() {
  return (
    <Routes>
      <Route path="/"                     element={<EmpresaIndex />} />
      <Route path="/grupo-empresas"       element={<SubPage tileKey="grupo-empresas" />} />
      <Route path="/proveedor-empresa"    element={<SubPage tileKey="proveedor-empresa" />} />
      <Route path="/contacto-grupo"       element={<SubPage tileKey="contacto-grupo" />} />
      <Route path="/contacto-empresa"     element={<SubPage tileKey="contacto-empresa" />} />
      <Route path="/servicio-empresa"     element={<SubPage tileKey="servicio-empresa" />} />
      <Route path="/precios"              element={<SubPage tileKey="precios" />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page:        { display: 'flex', flexDirection: 'column', gap: 28 },
  header:      { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox:     { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon:        { fontSize: 22, color: '#fff', display: 'flex' },
  title:       { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle:    { margin: 0, fontSize: 13, color: '#64748b' },
  placeholder: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '48px 24px', background: '#fff', border: '1px dashed #e2e8f0', borderRadius: 12 },
};
